var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import { Prop, Emit } from "vue-property-decorator";
import Component from "vue-class-component";
import { CityService } from "~/utils/city.service";
var AreaData = [
    { label: "华东", id: 1, children: [2440, 2134, 3146, 2245, 1501] },
    { label: "华北", id: 2, children: [3873, 1755, 2663, 2, 552, 3394] },
    { label: "华中", id: 3, children: [1156, 966, 734] },
    { label: "华南", id: 4, children: [3624, 3021, 157, 1293] },
    { label: "东北", id: 5, children: [3509, 2458, 1613] },
    { label: "西北", id: 6, children: [1871, 1989, 2528, 2635, 3821] },
    { label: "西南", id: 7, children: [2816, 1773, 3248, 2358, 926] },
    { label: "港澳台", id: 8, children: [2794, 2122, 252] }
];
// 省列表数据
var provinceDataList = CityService.getCityData({ level: 1 });
var AreaSelection = /** @class */ (function (_super) {
    __extends(AreaSelection, _super);
    function AreaSelection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cityData = [];
        return _this;
    }
    AreaSelection.prototype.getCheckedCitys = function () {
        var currentSelectCitys = [];
        this.cityData.forEach(function (group) {
            // 获取选择城市
            group.children.forEach(function (province) {
                var temp = province.citys
                    .filter(function (x) { return !!province.selectedCity.find(function (city) { return city === x.value; }); })
                    .map(function (x) { return ({ value: x.value, label: x.label }); });
                currentSelectCitys.push.apply(currentSelectCitys, temp);
            });
        });
        return currentSelectCitys;
    };
    AreaSelection.prototype.onSelectedCitysChange = function () {
        this.formatData();
    };
    AreaSelection.prototype.close = function () {
        this.reset();
    };
    AreaSelection.prototype.reset = function () {
        if (!this.cityData)
            return;
        this.cityData.forEach(function (group) {
            // 清空选择城市
            group.children.forEach(function (province) {
                var citys = province.citys.map(function (x) {
                    return { value: x.value, label: x.label };
                });
                province.selectedCity = [];
            });
            // 清空选择的省份
            group.selectedProvince = [];
            // 清空选择全部省份
            group.selectedAll = false;
        });
    };
    AreaSelection.prototype.onAreaCheckAllChange = function (area, state) {
        if (state) {
            area.selectedProvince = area.children.map(function (v) {
                v.selectedCity = v.citys.map(function (v) {
                    return v.value;
                });
                return v.value;
            });
        }
        else {
            area.selectedProvince = [];
            area.children.forEach(function (v) {
                v.selectedCity = [];
            });
        }
    };
    AreaSelection.prototype.onProvinceSelectChange = function (area, province, state) {
        province.selectedCity = state ? province.citys.map(function (x) { return x.value; }) : [];
        area.selectedAll = area.selectedProvince.length === area.children.length;
    };
    AreaSelection.prototype.onCitySelectChange = function (selectedProvince, province) {
        if (province.selectedCity.length === province.citys.length &&
            selectedProvince.indexOf(province.value) === -1) {
            selectedProvince.push(province.value);
        }
        else if (selectedProvince.indexOf(province.value) > -1) {
            selectedProvince.splice(selectedProvince.indexOf(province.value), 1);
        }
    };
    Object.defineProperty(AreaSelection.prototype, "indeterminateCountry", {
        // 计算全国选择 半选状态
        get: function () {
            return (this.cityData.some(function (area) {
                return area.children.some(function (p) { return p.selectedCity.length > 0; });
            }) && !this.countryChecked);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AreaSelection.prototype, "countryChecked", {
        get: function () {
            return !this.cityData.some(function (area) { return area.selectedProvince.length !== area.children.length; });
        },
        set: function (value) {
            var _this = this;
            this.cityData.forEach(function (area) {
                _this.onAreaCheckAllChange(area, value);
                area.selectedAll = value;
            });
        },
        enumerable: false,
        configurable: true
    });
    AreaSelection.prototype.created = function () {
        this.initData();
    };
    /**
     * 获取省份列表
     */
    AreaSelection.prototype.getProvinceList = function (provinceList) {
        var _this = this;
        return provinceList.map(function (provinceId) {
            var currentPovince = _this.$city
                .getCityData({ level: 1 })
                .find(function (p) { return p.value === provinceId; });
            return {
                value: currentPovince.value,
                label: currentPovince.label,
                citys: _this.$city.getCityData({ level: 1, id: provinceId }),
                selectedCity: [] // 当前选择的城市
            };
        });
    };
    /**
     * 初始区域信息
     */
    AreaSelection.prototype.initData = function () {
        var _this = this;
        this.cityData = AreaData.map(function (group) { return ({
            id: group.id,
            label: group.label,
            children: _this.getProvinceList(group.children),
            selectedProvince: [],
            selectedAll: false
        }); });
    };
    /**
     * 获取选择城市/省份数据
     */
    AreaSelection.prototype.formatData = function () {
        var _this = this;
        this.$nextTick(function () {
            _this.cityData.forEach(function (group) {
                // 获取选择城市
                group.children.forEach(function (province) {
                    var citys = province.citys.map(function (x) {
                        return { value: x.value, label: x.label };
                    });
                    province.selectedCity = _this.selectedCitys.filter(function (x) { return !!citys.find(function (city) { return city.value === x; }); });
                });
                // 获取选择的省份
                group.selectedProvince = group.children
                    .map(function (province) {
                    return province.selectedCity.length === province.citys.length
                        ? province.value
                        : "";
                })
                    .filter(function (x) { return x; });
                // 判断是否选择全部省份
                group.selectedAll =
                    group.children.length === group.selectedProvince.length;
            });
        });
    };
    __decorate([
        Prop()
    ], AreaSelection.prototype, "selectedCitys", void 0);
    __decorate([
        Prop({
            default: false,
            type: Boolean
        })
    ], AreaSelection.prototype, "disabled", void 0);
    __decorate([
        Emit("close")
    ], AreaSelection.prototype, "close", null);
    AreaSelection = __decorate([
        Component({})
    ], AreaSelection);
    return AreaSelection;
}(Vue));
export default AreaSelection;
